import client from './client';

export const broadcastTemplatesApi = {
  async list(teamId) {
    const { data } = await client.get('/api/broadcast-templates', { params: { teamId } });
    return data;
  },

  async create(payload) {
    const { data } = await client.post('/api/broadcast-templates', payload);
    return data;
  },

  async update(id, payload) {
    const { data } = await client.patch(`/api/broadcast-templates/${id}`, payload);
    return data;
  },

  async remove(id) {
    await client.delete(`/api/broadcast-templates/${id}`);
  },
};

export const broadcastsApi = {
  async list(teamId, params = {}) {
    const { data } = await client.get('/api/broadcasts', {
      params: { teamId, ...params },
    });
    return data;
  },

  async get(id) {
    const { data } = await client.get(`/api/broadcasts/${id}`);
    return data;
  },

  async preview(payload) {
    const { data } = await client.post('/api/broadcasts/preview', payload);
    return data;
  },

  async send(payload) {
    const { data } = await client.post('/api/broadcasts', payload);
    return data;
  },
};
